import Button from "devextreme-react/button";
import { useContext, useState } from "react";
import { AR, OrderStatus, ROType } from "../../../../types/enums";
import { RetailOrderContext } from "../context/RetailOrderContext";
import { RetailOrderProgressStep } from "../types/RetailOrderProgressStep";
import ChangeRequestPopup from "./ChangeRequestPopup";

export default function ViewChangeRequestButton(props: { step: RetailOrderProgressStep }) {

	const [isPopupVisible, setPopupVisibility] = useState(false);
	const { order } = useContext(RetailOrderContext);

	const isCabinetInstallOrder = order.details.roTypeID === ROType.CabinetInstallOrder &&
		order.details.orderStatusID !== OrderStatus.Cancelled &&
		order.details.orderStatusID !== OrderStatus.Closed;

	const changeRequestExists = order.details.changeOrderProducts?.filter(x => x.roProductChangeRequestID > 0).length > 0 &&
		(order.details.activeARs.includes(AR.DealerToConfirmChangeOrder) ||
			order.details.activeARs.includes(AR.SageToApproveChangeOrder) ||
			order.details.activeARs.includes(AR.PendingPostTemplatePayment) ||
			order.details.activeARs.includes(AR.InstallerToUploadVerificationForm) ||
			isCabinetInstallOrder);

	return (
		<>
			<Button
				elementAttr={{ 'data-testid': 'btn-view-change-request' }}
				text="View Change Request"
				icon="Inscyth-Change"
				visible={changeRequestExists && (isCabinetInstallOrder || !isCabinetInstallOrder && props.step === RetailOrderProgressStep.Confirm)}
				disabled={isPopupVisible}
				onClick={() => setPopupVisibility(true)}
			>
			</Button>
			{
				isPopupVisible &&
				<ChangeRequestPopup onHidePopup={() => setPopupVisibility(false)} />
			}
		</>
	)
}
